import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  plusolev77jfy5r9 as plus,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var MutableCoroutineContextClass;
function MutableCoroutineContext() {
  if (MutableCoroutineContextClass === VOID) {
    class $ {
      constructor() {
        this.xd8_1 = ArrayList().w();
      }
      yd8(element) {
        this.xd8_1.v(element);
      }
      fp(initial, operation) {
        // Inline function 'kotlin.collections.fold' call
        var accumulator = initial;
        var _iterator__ex2g4s = this.xd8_1.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          accumulator = operation(accumulator, element);
        }
        return accumulator;
      }
      cd(key) {
        var inductionVariable = get_lastIndex(this.xd8_1);
        if (0 <= inductionVariable)
          $l$loop: do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var tmp0_elvis_lhs = this.xd8_1.q1(index).cd(key);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            return tmp;
          }
           while (0 <= inductionVariable);
        return null;
      }
      ep(key) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (MutableCoroutineContext())();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.xd8_1.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (element.cd(key) == null) {
            this_0.yd8(element);
          }
        }
        return this_0;
      }
    }
    protoOf($).gp = plus;
    initMetadataForClass($, 'MutableCoroutineContext', MutableCoroutineContext, VOID, [CoroutineContext()]);
    MutableCoroutineContextClass = $;
  }
  return MutableCoroutineContextClass;
}
//region block: exports
export {
  MutableCoroutineContext as MutableCoroutineContext2j9pn5zmhi2pt,
};
//endregion

//# sourceMappingURL=MutableCoroutineContext.mjs.map
